module.exports = __webpack_public_path__ + "static/media/bt_top_moff_check_over.baff1c8a.png";